{
    "warning": "সতর্কীকরণ!",
    "message": "আপনি বুঝতে পারছে না এমন কোড লিখবে না বা পেস্ট করবেন না।\nএই কনসোলটি ব্যবহার করে আক্রমণকারীরা আপনার ছদ্মবেশ ধারণ করতে পারে এবং Self-XSS নামক আক্রমণ পদ্ধতি ব্যবহার করে আপনার তথ্য চুরি করতে পারে।"
}
